import {
  Box,
  Button,
  Grid,
  Typography,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Slide,
  Select,
  MenuItem,
  Stack,
} from "@mui/material";
import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { format } from "date-fns";
import { driverLeaveApis } from "../../../Data/axios";
import { getUserInfo } from "../../../Data/UserData";
import StatusAlert from "../../../StatusAlertList/StatusAlert";
import ReactQuill from "react-quill";
import config from "../../../Data/AuthUser";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ViewMoreLeaveDriver = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const rowData = location.state;

  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("info");

  const [remarkOpen, setRemarkOpen] = useState(false);
  const [statusType, setStatusType] = useState("");
  const [remark, setRemark] = useState("");

  const showAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const {
    id,
    created_at,
    driver_id,
    owner_id,
    start_date,
    end_date,
    type,
    reason,
    status,
    approved_by,
    approved_at,
    file,
    note,
    app_user_driver,
    owner,
    approver,
  } = rowData || {};

  const driverName = app_user_driver?.username || driver_id || "";
  const driverImage = app_user_driver?.image || "";
  const clientName = owner?.username || owner_id || "";
  const clientImage = owner?.image || "";
  const approvedByName = approver?.name || approved_by || "N/A";

  const formattedLeaveDate = (date) => {
    if (!date) return "N/A";
    try {
      return format(new Date(date), "dd-MM-yyyy");
    } catch {
      return date;
    }
  };

  const formattedDateTime = (dateStr) => {
    if (!dateStr) return "N/A";
    try {
      let date;
      const str = String(dateStr).trim();

      if (str.endsWith("Z") || /[-+]\d{2}:\d{2}$/.test(str)) {
        // ISO string with timezone info — JS parses correctly
        date = new Date(str);
      } else if (/\s*UTC$/i.test(str)) {
        // Old format "YYYY-MM-DD HH:mm:ss UTC" — treat the time as UTC
        const clean = str.replace(/\s*UTC$/i, "").trim();
        date = new Date(clean + "Z");
      } else {
        // No timezone info — assume UTC to be safe
        date = new Date(str + "Z");
      }

      if (isNaN(date.getTime())) return dateStr;

      return date.toLocaleString("en-IN", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      });
    } catch {
      return dateStr;
    }
  };

  const convertToPlainText = (htmlContent) => {
    if (!htmlContent) return "";
    const parser = new DOMParser();
    const parsedHtml = parser.parseFromString(htmlContent, "text/html");
    return parsedHtml.body.textContent || "";
  };

  const leaveTypeLabel = (value) => {
    if (value === "1") return "One Day";
    if (value === "2") return "Multiple Days";
    return "Unknown";
  };

  const statusLabel = (value) => {
    if (value === "0" || value === 0)
      return (
        <span style={{ color: "red", fontWeight: 600 }}>Rejected</span>
      );
    if (value === "1" || value === 1)
      return (
        <span style={{ color: "#ed6c02", fontWeight: 600 }}>Applied</span>
      );
    if (value === "2" || value === 2)
      return (
        <span style={{ color: "green", fontWeight: 600 }}>Approved</span>
      );
    return <span>Unknown</span>;
  };

  const handleApproveReject = () => {
    setRemarkOpen(true);
  };

  const handleSaveRemark = async () => {
    if (!statusType && statusType !== 0) {
      showAlert("Please select a status", "error");
      return;
    }
    const userInfoString = localStorage.getItem("user-info");
    const userInfo = userInfoString ? JSON.parse(userInfoString) : null;
    const currentUserName = userInfo?.value?.name || getUserInfo() || "";

    const formData = new FormData();
    formData.append("status", statusType);
    formData.append("approved_by", currentUserName);
    formData.append("approved_at", new Date().toISOString());
    formData.append("note", remark);

    try {
      await driverLeaveApis.remarkById(id, formData);
      showAlert("Status updated successfully", "success");
      setRemarkOpen(false);
      setStatusType("");
      setRemark("");
      // Update local state to reflect the change
      rowData.status = String(statusType);
      rowData.approved_by = currentUserName;
      rowData.approved_at = new Date().toISOString();
      rowData.note = remark;
    } catch {
      showAlert("Failed to update status", "error");
    }
  };

  const handleCloseRemark = () => {
    setRemarkOpen(false);
    setStatusType("");
    setRemark("");
  };

  const isPending = status === "1" || status === 1;

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image"],
      ["clean"],
    ],
  };

  const DetailRow = ({ label, children }) => (
    <Grid container spacing={4} sx={{ borderBottom: "1px solid #f0f0f0" }}>
      <Grid item xs={4}>
        <Typography
          variant="body1"
          sx={{ color: "#333", padding: "14px 20px", fontSize: "14px", fontWeight: 500 }}
        >
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography
          variant="body1"
          sx={{ color: "#555", padding: "14px 0", fontSize: "14px" }}
        >
          {children}
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ color: "#333", padding: "10px", fontSize: "20px", fontWeight: 550 }}>
      <StatusAlert
        open={alertOpen}
        setOpen={setAlertOpen}
        message={alertMessage}
        severity={alertSeverity}
      />

      {/* Approve/Reject Dialog */}
      <Dialog
        fullWidth
        maxWidth="md"
        open={remarkOpen}
        onClose={handleCloseRemark}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            position: "absolute",
            top: "0",
            backgroundColor: "white",
            maxHeight: "95%",
            margin: "auto",
            overflowX: "hidden",
            zIndex: 1200,
          },
        }}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={handleCloseRemark} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} component="div">
              Update Leave Status
            </Typography>
          </Toolbar>
        </AppBar>

        <Box sx={{ background: "#fff", p: 3 }}>
          <Grid container spacing={4} style={{ color: "black" }}>
            <Grid item xs={11} sm={4} md={3}>
              <Stack direction="column">
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Status
                </Typography>
                <Select
                  value={statusType}
                  autoFocus
                  onChange={(e) => setStatusType(parseInt(e.target.value, 10))}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  sx={{
                    border: "1px solid black",
                    boxSizing: "border-box",
                    "& .MuiOutlinedInput-root": {
                      borderColor: "black !important",
                      "&:hover fieldset": { borderColor: "black !important" },
                      "&.Mui-focused fieldset": { borderColor: "black !important" },
                    },
                    color: "black",
                  }}
                  renderValue={(selected) => {
                    if (selected === "" || selected === undefined) {
                      return <span style={{ color: "gray" }}>Select Status</span>;
                    }
                    if (selected === 0) return "Rejected";
                    if (selected === 2) return "Approved";
                    return "Unknown";
                  }}
                >
                  <MenuItem value={0}>Rejected</MenuItem>
                  <MenuItem value={2}>Approved</MenuItem>
                </Select>
              </Stack>
            </Grid>
            <Grid item xs={11} sm={7.5} md={8.5}>
              <Stack direction="column" sx={{ width: "100%" }}>
                <Typography variant="p" gutterBottom style={{ color: "black" }}>
                  Remark<span style={{ color: "red" }}>*</span>
                </Typography>
                <ReactQuill
                  value={remark}
                  onChange={setRemark}
                  modules={modules}
                  theme="snow"
                  style={{
                    width: "100%",
                    height: "70px",
                    boxSizing: "border-box",
                    color: "black",
                  }}
                />
              </Stack>
            </Grid>
          </Grid>

          <Grid container sx={{ padding: "50px 0 30px 0" }}>
            <Grid item xs={11} sx={{ display: "flex", gap: 2 }}>
              <Box
                onClick={handleSaveRemark}
                sx={{
                  padding: "8px 24px",
                  backgroundColor: "#1976d2",
                  color: "#fff",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: 500,
                  "&:hover": { backgroundColor: "#1565c0" },
                }}
              >
                Save
              </Box>
              <Box
                onClick={handleCloseRemark}
                sx={{
                  padding: "8px 24px",
                  border: "1px solid #ccc",
                  color: "#333",
                  borderRadius: "4px",
                  cursor: "pointer",
                  fontWeight: 500,
                  "&:hover": { backgroundColor: "#f5f5f5" },
                }}
              >
                Cancel
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Dialog>

      <Box sx={{ color: "#333", bgcolor: "#fff", height: "auto" }}>
        {/* Header */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid rgb(187, 186, 186)",
            p: 2,
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <IconButton onClick={() => navigate(-1)} size="small">
              <ArrowBackIcon />
            </IconButton>
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Driver Leave Request Details
            </Typography>
          </Box>
          {isPending && (
            <Button
              variant="contained"
              onClick={handleApproveReject}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                backgroundColor: "#1976d2",
                "&:hover": { backgroundColor: "#1565c0" },
              }}
            >
              Approve / Reject
            </Button>
          )}
        </Box>

        {/* Body */}
        <Box>
          <DetailRow label="Driver's Name">
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              {driverImage ? (
                <img
                  src={`${config.apiImageUrl}${driverImage}`}
                  alt="driver"
                  style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover" }}
                />
              ) : null}
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{driverName}</Typography>
                <Typography variant="caption" sx={{ color: "#999" }}>{driver_id || ""}</Typography>
              </Box>
            </Box>
          </DetailRow>

          <DetailRow label="Client's Name">
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              {clientImage ? (
                <img
                  src={`${config.apiImageUrl}${clientImage}`}
                  alt="client"
                  style={{ width: 36, height: 36, borderRadius: "50%", objectFit: "cover" }}
                />
              ) : null}
              <Box>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>{clientName}</Typography>
                <Typography variant="caption" sx={{ color: "#999" }}>{owner_id || ""}</Typography>
              </Box>
            </Box>
          </DetailRow>

          <DetailRow label="Leave Period">
            {formattedLeaveDate(start_date)} {end_date ? `To ${formattedLeaveDate(end_date)}` : ""}
          </DetailRow>

          <DetailRow label="Leave Type">
            {leaveTypeLabel(type)}
          </DetailRow>

          <DetailRow label="Reason">
            {reason || "No reason provided"}
          </DetailRow>

          <DetailRow label="Status">
            {statusLabel(status)}
          </DetailRow>

          <DetailRow label="Note">
            {convertToPlainText(note) || "No remark"}
          </DetailRow>

          <DetailRow label="File">
            {file ? (
              <a
                href={`${config.apiBaseUrl?.replace("/api", "/public/") || "https://rptpl.roadpilot.co.in/public/"}${file}`}
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1976d2", textDecoration: "none" }}
              >
                View Attachment
              </a>
            ) : (
              "No file attached"
            )}
          </DetailRow>

          <DetailRow label="Requested At">
            {formattedDateTime(created_at)}
          </DetailRow>

          <DetailRow label="Approved By">
            {approvedByName}
          </DetailRow>

          <DetailRow label="Approved At">
            {formattedDateTime(approved_at)}
          </DetailRow>
        </Box>
      </Box>
    </Box>
  );
};

export default ViewMoreLeaveDriver;
